import React from 'react';
import ProductList from './ProductList';
import '../../styles/Dashboard.css';

const Products = () => {
  return (
    <div className="section dashboard-container">
      <ProductList />
    </div>
  );
};

export default Products;
